"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es.function.name.js");

var __vue_render__ = function __vue_render__(h) {
  var _vm = this;

  var _h = _vm.$createElement;
  var _c = h;
  return _c('i', {
    "class": 'el-icon-' + _vm.name,
    attrs: {}
  });
};

var __vue_staticRenderFns__ = [];
var _default = {
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__,
  name: 'ElIcon',
  props: {
    name: String
  }
};
exports["default"] = _default;